<template>
  <div class="container-fluid mt-4" style="max-width: 1400px">
    <br/>
    <b-card class="mt-2" style="font-weight: bold;">
      <span style="float:left"><h3>Support Ticket # {{model.id}}</h3></span>
      <span style="float:right"><b-button variant="success" size="md" :to="{ name: 'support_ticket_list' }"><span style="color:white">Back To List</span></b-button></span>
      <br/><br/><hr/>

      <form v-if="model">

        <table cellpadding="10" cellspacing="10" width="100%" style="font-size: 18px">
          <tr v-if="user.role === 'admin'">
            <td align="left" valign="top">
                <h5>Account</h5>
                <b-form-select v-model="model.new_tenant_id" :options="user.tenant_options" />
            </td>
            <td align="left" valign="top">
              <h5>Dev Ticket</h5>
              <b-form-input type="text" v-model="model.dev_ticket" />
            </td>
            <td align="left" valign="top" colspan="2">
              <h5>Internal Notes</h5>
              <b-form-textarea style="field-sizing: content" v-model="model.internal_notes" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Account</h5>
              <span>{{getOptionText(user.tenant_options, model.tenant_id)}}</span>
            </td>
            <td align="left" valign="top">
              <h5>Type</h5>
              <span>{{summary.tenant_type}} / {{summary.telematics_type}}</span>
            </td>
            <td align="left" valign="top" colspan="3">
              <h5>Additional Contacts (comma separated emails)</h5>
              <b-form-input type="text" v-model="model.additional_contacts" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Status</h5>
              <span v-if="user.role === 'admin'">
                <b-form-select style="width: 250px" v-model="model.ticket_status" :options="statusOptions" />
              </span>
              <span v-else>
                <b-form-select style="width: 200px" v-model="model.ticket_status" :options="statusOptions" disabled />
                <span v-if="model.ticket_status == 'completed'">
                  &nbsp;<b-button v-on:click.prevent="update_ticket_status('new')">Reopen</b-button>
                </span>
                <span v-if="model.ticket_status == 'waiting'">
                  &nbsp;<b-button v-on:click.prevent="update_ticket_status('approved')">Approve</b-button>
                </span>
                <span v-if="model.ticket_status != 'completed' && model.ticket_status != 'cancelled'">
                  &nbsp;<b-button v-on:click.prevent="update_ticket_status('cancelled')">Cancel</b-button>
                </span>
              </span>
            </td>
            <td align="left" valign="top">
              <h5>Created By</h5>
                <span v-if="user.role === 'admin'">
                  <b-form-select style="width: 300px" v-model="model.username" :options="user_options" />
                </span>
                <span v-else>
                  <div style="text-align: left; font-weight: bold">{{model.username}}</div>
                </span>
            </td>
            <td align="left" valign="top">
              <h5>Creator Role</h5>
              <b-form-input type="text" v-model="model.creator_role" style="width:300px" />
            </td>
            <td align="left" valign="top">
              <h5>Assigned To</h5>
                <span v-if="user.role === 'admin'">
                  <b-form-select style="width: 250px" v-model="model.assigned_to" :options="assigned_options" />
                </span>
                <span v-else>
                  <span style="text-align: left; font-weight: bold">{{getOptionText(assigned_options, model.assigned_to)}}</span>
                </span>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Feature</h5>
              <b-form-select style="width: 250px" v-model="model.category" :options="categoryOptions" />
            </td>
            <td align="left" valign="top">
              <h5>Priority</h5>
              <b-form-select style="width: 250px" v-model="model.priority" :options="priorityOptions" />
            </td>
            <td align="left" valign="top">
              <h5>Created</h5>
              <span>{{ model.created_at | formatDateTimeSmall }}</span>
            </td>
            <td align="left" valign="top">
              <h5>Last Updated</h5>
              <span>{{ model.updated_at | formatDateTimeSmall }}</span>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top">
              <h5>Estimated Dev</h5>
              <div style="font-size: 18px; font-weight: bold; position: relative;" class="d-flex align-items-center">
                <b-form-input type="text" v-model="model.estimated_hours" style="width:60px" :disabled="user.role != 'admin'"/>&nbsp;hours {{cost_estimate}}
              </div>
              </td>
            <td align="left" valign="top">
              <h5>Actual Dev</h5>
              <div style="font-size: 18px; font-weight: bold; position: relative;" class="d-flex align-items-center">
                <b-form-input type="text" v-model="model.actual_hours" style="width:60px" :disabled="user.role != 'admin'"/>&nbsp;hours {{cost_actual}}
              </div>
            </td>
            <td align="left" valign="top">
              <h5>Target Date</h5>
                <div v-if="user.role === 'admin'" style="font-size: 18px; font-weight: bold; position: relative;">
                  <date-picker style="font-size: 18px; font-weight: bold; width:140px" v-model="selected_target_date" :placeholder="selected_target_date" :config="options"/>
                </div>
              <div v-else>{{model.estimated_finish_date}}</div>
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="4">
              <h5>Subject</h5>
              <b-form-input type="text" v-model="model.subject" />
            </td>
          </tr>
          <tr>
            <td align="left" valign="top" colspan="4">
              <h5>Description (text only)</h5>
              <b-form-textarea v-model="model.description" style="field-sizing: content" />
            </td>
          </tr>
        </table>

        <br/>
        <div>
          <b-button  @click="saveSupportTicket(true)" variant="success" id="create-user-submit">
            Save
          </b-button>
          &nbsp;&nbsp;
          <b-button v-if="user.role === 'admin'" @click="saveSupportTicket(false)" variant="success" id="create-user-submit">
            Save (no email)
          </b-button>
          &nbsp;&nbsp;
          <b-button :to="{ name: 'support_ticket_list' }">
            Cancel
          </b-button>
        </div>
      </form>
    </b-card>

    <b-card v-if="model" title="Comments & Attachments" class="mt-4" style="font-weight: bold;">
      <div class="container">
        <div class="row">
          <div class="col-1 col-md-3">
            New Comment:
          </div>
          <div class="col-1 col-md-7" style="text-align: left !important;" >
            <b-form-group>
              <b-form-textarea v-model="newComment" style="field-sizing: content"/>
              <br/>
              <input id="comment_attachments" type="file" multiple @change="handleFileUpload" />
            </b-form-group>
          </div>
          <div class="col-1 col-md-1">
            <template v-if="!this.wait_for_posting">
              <b-button type="submit" variant="success" @click="postNewComment">Post</b-button>
            </template>
            <template v-else>
              <b-button type="submit" variant="disabled" @click="postNewComment">Posting...</b-button>
            </template>
          </div>
        </div>
      </div>

      <br/>

      <b-table id="comments_table"
        :items="preparedComments"
        :fields="commentFields"
        :primary-key="'comment_id'"
        sort-by="created_at"
        :sort-desc="true"
        striped
        hover
        bordered
        small
      >
        <template slot="created_at" slot-scope="row" >
          {{ formatDate(row.item.created_at) }}
        </template>

        <template slot="username" slot-scope="row">
            <span v-if="row.item.username && getOptionText(assigned_options, row.item.username) != row.item.username">
              {{getOptionText(assigned_options, row.item.username)}}
            </span>
          <span v-else-if="row.item.username">{{row.item.username.split('@')[0]}}</span>
        </template>

        <template slot="comment" slot-scope="row">
          <template v-if="row.item.editing">
            <b-form-textarea
              v-model="row.item.tempComment"
              class="mb-2"
              rows="3"
              max-rows="12"
            ></b-form-textarea>
            <b-button size="sm" variant="success" @click="saveComment(row.item)">Save</b-button>
            &nbsp;
            <b-button size="sm" variant="secondary" @click="cancelEdit(row.item)">Cancel</b-button>
          </template>
          <template v-else>
            <div style="white-space: pre-wrap;max-height: 220px;overflow-y: auto; border: 1px dotted #ccc; padding: 10px;">
              <span v-html="add_links(row.item.comment)"/>
            </div>
          </template>
          <div v-if="row.item.attachments && row.item.attachments.length">
            <br/>
            <div style="font-weight: bold;">Attachments:</div>
            <ul>
              <li v-for="attachment in row.item.attachments" :key="attachment">
                <a :href="attachment" target="_blank">{{extractFileNameFromUpload(attachment)}}</a>
              </li>
            </ul>
          </div>
        </template>

        <template slot="actions" slot-scope="row">
          <div style="text-align: center;">
            <template v-if="!row.item.editing">
              <template v-if="canEditComment(row.item)">
                <img src="/edit.png" alt="Edit" style="height: 1.25rem; margin: 10px; text-align: center !important; cursor: pointer" @click="startEdit(row.item)"/>
              </template>
              <template v-if="canDeleteComment(row.item)">
                <img src="/delete.png" alt="Delete" style="height: 1.25rem; margin: 10px; text-align: center !important; cursor: pointer" @click="deleteComment(row.item)"/>
              </template>
            </template>
          </div>
        </template>
      </b-table>

      <div v-if="!model.comments || model.comments.length === 0" class="text-muted mt-2">
        No comments yet.
      </div>
    </b-card>

    <b-card v-if="user.role == 'admin' && history" title="" class="mt-4">
      <span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(history,'isHistoryVisible')">Show Ticket History</span>
      <br/><br/>
      <span :style="history.isHistoryVisible ? '' : 'display:none'">
        <b-table id="history_table"
          :items="history"
          :fields="historyFields"
          :primary-key="'comment_id'"
          sort-by="created_at"
          :sort-desc="true"
          striped
          hover
          bordered
          small
        >
          <template slot="processed_time" slot-scope="row">
            {{ row.item.processed_time | formatDateTimeSmall }}
          </template>

          <template slot="updated_by" slot-scope="row">
            <span v-if="row.item.updated_at && getOptionText(assigned_options, row.item.updated_by) != row.item.updated_by">
              {{getOptionText(assigned_options, row.item.updated_by)}}
            </span>
            <span v-else-if="row.item.updated_by">{{row.item.updated_by.split('@')[0]}}</span>
          </template>

          <template slot="diff" slot-scope="row">
            <span v-if="row.item.diff">
              <span v-if="row.item.diff.subject">
                Subject: {{ row.item.diff.subject }}<br/>
              </span>
              <span v-if="row.item.diff.assigned_to">
                Assigned To: {{getOptionText(assigned_options, row.item.diff.assigned_to)}}<br/>
              </span>
              <span v-if="row.item.diff.ticket_status">
                Status: {{getOptionText(statusOptions,row.item.diff.ticket_status)}}<br/>
              </span>
              <span v-if="row.item.diff.description">
                Description: {{row.item.diff.description}}<br/>
              </span>
            </span>
            <span v-else>
                Subject: {{ row.item.subject }}<br/>
                Description: {{row.item.description}}
            </span>
          </template>
        </b-table>
     </span>
    </b-card>
  </div>

</template>

<script>
import {
  delete_support_ticket_comment,
  get_support_ticket, get_primary_users,
  update_support_ticket,
  update_support_ticket_comment
} from '../networking/apis'
import { mapState } from "vuex"
import moment from "moment"
import {justDate} from "@/helpers/dates";

export default {
  name: 'SupportTicketDetails',
  data () {
    return {
      selected_tenant_id: null,
      tenant_id: null,
      ticket_id: null,
      history: [],
      summary: {},            // The support ticket data
      model: {},            // The support ticket data
      newComment: '',       // New comment text
      attachments: [],      // New comment file attachments
      wait_for_posting: false,
      selected_target_date: null,
      user_options: [],
      commentFields: [
        { key: 'created_at', label: 'Added At', sortable: true, thStyle: { width: "150px" } },
        { key: 'username', label: 'Added By', sortable: true, thStyle: { width: "150px" } },
        { key: 'comment',    label: 'Comments', sortable: false },
        { key: 'actions',    label: 'Actions', sortable: false, thStyle: { width: "100px" } }
      ],
      historyFields: [
        { key: 'processed_time', label: 'Update Time', sortable: true, thStyle: { width: "160px" } },
        { key: 'updated_by', label: 'Update By', sortable: true, thStyle: { width: "160px" } },
        { key: 'diff', label: 'Changes Made', sortable: true, thStyle: { width: "600px" } },
      ],
      categoryOptions: [
        {value: 'general', text: 'General'},
        {value: 'actuals', text: 'Actuals'},
        {value: 'alerts', text: 'Alerts'},
        {value: 'maps', text: 'Map Views'},
        {value: 'reports', text: 'View & Reports'},
        {value: 'vsm', text: 'Vehicle Status Manager'},
        {value: 'data', text: 'Data Services'},
        {value: 'fleet-assistant', text: 'Fleet Assistant'},
      ],
      priorityOptions: [
        {value: 'question', text: 'Question/Request'},
        {value: 'minor', text: 'Minor Bug'},
        {value: 'urgent', text: 'Major Bug / System Issue'},
        {value: 'enhancement', text: 'Enhancement Request'},
        {value: 'feature', text: 'New Feature Request'},
      ],
      statusOptions: [
        { value: 'new', text: 'New' },
        { value: 'queued', text: 'Queued' },
        { value: 'progress', text: 'In Progress' },
        { value: 'waiting', text: 'Waiting On Customer' },
        { value: 'approved', text: 'Customer Approved' },
        { value: 'testing', text: 'Customer Testing' },
        { value: 'cancelled', text: 'Cancelled' },
        { value: 'completed', text: 'Completed' },
      ],
      assigned_options: [
        { value: null, text: 'Unassigned' },
        { value: 'ben@initekconsulting.com', text: 'Ben ODay' },
        { value: 'jen@initekconsulting.com', text: 'Jen Mayer' },
        { value: 'chaz@initekconsulting.com', text: 'Chaz Watson' },
        { value: 'kai@initekconsulting.com', text: 'Kai Klein' },
        { value: 'evan@initekconsulting.com', text: 'Evan Anderson' },
      ],
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment(),
        maxDate: moment().add(180, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
    }
  },
  async created() {
    this.selected_tenant_id = this.user.tenant
    this.ticket_id = this.$route.query.id
    this.tenant_id = this.$route.query.tenant_id
    if (this.user.role == 'admin')
      await this.load_users()
    await this.load_data()
  },
  computed: {
    ...mapState({
      user: state => state.profile.user
    }),
    preparedComments() {
      return this.model.comments || []
    },
    cost_estimate() {
      if (this.model.estimated_hours) {
        return ' ($' + this.model.estimated_hours * 150 + ')';
      }
    },
    cost_actual() {
      if (this.model.actual_hours) {
        return ' ($' + this.model.actual_hours * 150 + ')';
      }
    },
  },
  methods: {
    add_links(text) {
      const Rexp = /(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;
      return text.replace(Rexp, "<a href='$1' target='_blank'>$1</a>");
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    async load_users() {
      const {value: {data = []}} = await get_primary_users(this.tenant_id)
      this.user_options = data.results.map(item => ({
        value: item['username'],
        text: item['username']
    }));
      this.user_options.concat(this.assigned_options)
    },
    async load_data() {
      try {
        const results = await get_support_ticket(this.tenant_id, this.ticket_id)
        const {value: { data = [] } } = results
        this.history = data.history
        this.model = data.item
        this.summary = data.summary
        this.model.new_tenant_id = this.model.tenant_id
        if (this.model.estimated_finish_date)
          this.selected_target_date = justDate(moment(this.model.estimated_finish_date,'MM-DD-YYYY'))

        if (this.model.comments) {
          this.model.comments.forEach((comment, idx) => {
            this.$set(this.model.comments[idx], 'editing', false)
            this.$set(this.model.comments[idx], 'tempComment', comment.comment)
          })
        }
      } catch(e) {
        console.error('Error fetching support ticket:', e)
        this.$emit('showAlert', 'Error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    update_ticket_status(new_status) {
      this.model.ticket_status = new_status
      this.saveSupportTicket()
    },
    async saveSupportTicket (send_email) {
      try {
//        const { comments, ...ticketFields } = this.model
        this.$emit('showAlert', "Saving support ticket...", 'info')
        const response = await update_support_ticket(this.model.tenant_id, this.model, send_email)
        const message = (response && response.message) || 'Support ticket updated successfully!'
        this.$emit('showAlert', message, 'success', 1500)
        this.load_data()
      } catch(e) {
        this.$emit('showAlert', 'Error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },

    handleFileUpload(event) {
      this.attachments_target = event.target.files
      this.attachments = Array.from(event.target.files);
    },

    async postNewComment() {
      const text = this.newComment.trim()
      if (!text) {
        alert('Comment cannot be empty')
        return
      }
      try {
        this.$emit('showAlert', "Adding support ticket comment...", 'info')
        this.wait_for_posting = true

        const formData = new FormData();
        formData.append('comment', text);
        if (this.attachments) {
          this.attachments.forEach(file => {
            formData.append('attachments', file);
          });
        }

        let xhr = new XMLHttpRequest();
        if (this.selected_tenant_id == null) {
          this.$emit('showAlert', 'Error adding comment, try again', 'danger')
          return
        }
        let url = process.env.VUE_APP_API_URL + 'bookings/support_ticket/comment?tenant=' + this.selected_tenant_id + '&ticket_id=' + this.model.id
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Accept','*/*')
        xhr.setRequestHeader('Access-Control-Allow-Origin','*')
        //xhr.setRequestHeader('Access-Control-Allow-Headers','Authorization,Content-type')
        xhr.setRequestHeader('Authorization',`Bearer ${localStorage.getItem('jwt')}`)
        xhr.addEventListener("error", function () {
            console.log("An error occurred while sending the request.");
            this.$emit('showAlert', 'Error adding comment, try again', 'danger')
        }); 
        xhr.onload = function () {
          // do something to response
          //console.log(this.responseText);
        }
        xhr.onloadend  = () => {
          if (xhr.status == 200) {
            //console.log("success");
            
            this.$emit('showAlert', 'Attachment added successfully', 'success', 5000)
            this.newComment = ''
            this.attachments = null
            document.getElementById('comment_attachments').value= null;
            this.load_data()

          } else {
            console.log("error " + this.status);
          }
        };
        xhr.send(formData);

        this.wait_for_posting = false

      } catch(e) {
        this.$emit('showAlert', 'Error adding comment, try again: ' + e, 'danger', 5000)
        this.wait_for_posting = false
      }
    },
    setSuccessMessage(message) {
      this.$emit('showAlert', message, 'success', 5000)
    },

    canEditComment(commentItem) {
      return (
        this.user.role === 'admin' ||
        commentItem.username === this.user.username
      )
    },

    canDeleteComment(commentItem) {
      return (
        this.user.role === 'admin' ||
        commentItem.username === this.user.username
      )
    },

    startEdit(commentItem) {
      commentItem.editing = true
    },

    cancelEdit(commentItem) {
      commentItem.editing = false
      commentItem.tempComment = commentItem.comment
    },

    async saveComment(commentItem) {
      if (!this.canEditComment(commentItem)) {
        this.$emit('showAlert', 'Not authorized to update this comment.', 'danger', 3000)
        return
      }
      const updatedText = commentItem.tempComment.trim()
      if (!updatedText) {
        this.$emit('showAlert', 'Comment cannot be empty', 'warning', 2500)
        return
      }

      try {
        this.$emit('showAlert', "Updating support ticket comment...", 'info')
        const response = await update_support_ticket_comment(this.model.tenant_id, { ticket_id: this.model.id,
          comment_id: commentItem.comment_id,
          comment: updatedText })

        if (response.value && response.value.data && response.value.data.status === 'success') {
          this.$emit('showAlert', 'Comment updated successfully!', 'success', 1500)
          commentItem.comment = updatedText
          commentItem.editing = false
          commentItem.updated_at = moment().format()
        } else {
          this.$emit('showAlert', response.value.message || 'Failed to edit comment.', 'danger', 5000)
        }
      } catch (err) {
        this.$emit('showAlert', 'Error editing comment, try again', 'danger', 5000)
      }
    },

    async deleteComment(commentItem) {
      if (!this.canDeleteComment(commentItem)) {
        this.$emit('showAlert', 'Not authorized to delete this comment.', 'danger', 3000)
        return
      }
      if (!confirm('Are you sure you want to delete this comment?')) {
        return
      }

      try {
        this.$emit('showAlert', "Updating support ticket comment...", 'info')
        const response = await delete_support_ticket_comment(this.model.tenant_id, { ticket_id: this.model.id,
          comment_id: commentItem.comment_id })

        if (response.value && response.value.data && response.value.data.status === 'success') {
          this.$emit('showAlert', 'Comment deleted successfully!', 'success', 1500)

          const serverData = response.value.data
          let updatedComments = null
          if (serverData && serverData.Attributes && serverData.Attributes.comments) {
            updatedComments = serverData.Attributes.comments
          }

          if (Array.isArray(updatedComments)) {
            this.model.comments = updatedComments
          } else {
            this.model.comments = this.model.comments.filter(
              (c) => c.comment_id !== commentItem.comment_id
            )
          }
        } else {
          this.$emit('showAlert', response.data.message || 'Failed to delete comment.', 'danger', 5000)
        }
      } catch (err) {
        this.$emit('showAlert', 'Error deleting comment, try again', 'danger', 5000)
      }
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      return moment(dateStr).format('MM/DD hh:mm A') // e.g., "01/16 03:43 PM"
    },

    extractFileNameFromUpload(url) {
        const match = url.match(/_(.*)/);
        return match ? match[1] : null;
    },

    getOptionText(options, value) {
      const option = options.find(opt => opt.value === value)
      return option ? option.text : value
    },

    getEditedAgo(created_at, updated_at) {
      if (updated_at && updated_at !== created_at) {
        return 'Edited ' +  moment(updated_at).from(moment.now())
      }
      else {
        return ''
      }

    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    selected_target_date() {
      this.model.estimated_finish_date = moment(this.selected_target_date).format('MM-DD-YYYY')
    }
  }
}
</script>

<style>
  #comments_table td {
    vertical-align: top !important;
    text-align: left !important;
    padding: 0.5rem !important;
  }
  .edited-time {
    font-size: .75rem;
    color: #666666 !important;
  }
</style>